import { useSelector } from "react-redux";
import InputSinNumber from "../../../../components/input/InputSinNumber";

import ColOpcion from "./ColOpcion";
import ColTitulo from "./ColTitulo";
import RowCosto from "./RowCosto";

export default function ServicioEpson() {

  const {
   
    servicioEpsonOpcion1,
    servicioEpsonOpcion2,
    servicioEpsonOpcion3,
    servicioEpsonOpcion4,
    servicioEpsonOpcion5,
  } = useSelector((state) => state.cotizacionesReducer.cotizacion);


  return (
    <RowCosto>
      <ColTitulo>Servicio Epson</ColTitulo>
      <ColOpcion>
        <InputSinNumber value={servicioEpsonOpcion1} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={servicioEpsonOpcion2} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={servicioEpsonOpcion3} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={servicioEpsonOpcion4} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={servicioEpsonOpcion5} disabled />
      </ColOpcion>
    </RowCosto>
  );
}
